import styled from "@emotion/styled";

const SelectListItem = styled("li")({
  padding: "0.3125rem 0.3125rem",
  cursor: "pointer",
});

export default SelectListItem;
